<template>
  <div class="orderTest-container">
    <banner></banner>
    <instance></instance>
    <architecture></architecture>
    <cloudService></cloudService>
    <OSconstitute></OSconstitute>
  </div>
</template>
<script>
  import banner from "./components/banner.vue";
  import instance from "./components/instance.vue";
  import architecture from "./components/architecture.vue";
  import cloudService from "./components/cloudService.vue";
  import OSconstitute from "./components/OSconstitute.vue";
  export default {
    name: "",
    components: { banner, instance, architecture, cloudService,OSconstitute },
    data() {
      return {};
    },
    created() {},
    mounted() {},
    computed: {},
    watch: {},
    methods: {},
  };
</script>
